import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { PrimaryTopBar } from './top-bar';
import {
  SendWSMessageProvider,
  useSendSocketMessage,
} from '../send-message-ctx';
import { noop } from 'lodash';
import { adMob } from '@/shared/lib';
import { useNativeKeyboardBehavior } from '@/shared/hooks';

function normalizePathName(path: string) {
  return path
    .replace(/\/+$/, '') // Remove trailing slashes
    .replace(/^\/+/, '') // Remove leading slashes
    .split('-') // Split by hyphens
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(' '); // Join with spaces
}

export const BhabiAppLayoutWithoutCtx: FC<PropsWithChildren> = ({
  children,
}) => {
  const { sendMessage } = useSendSocketMessage();
  const { pathname } = useLocation();
  useNativeKeyboardBehavior();

  useEffect(() => {
    const pathName = pathname.split('/').pop();
    document.body.setAttribute('data-page', pathName || 'home');
    document.title = `${pathName ? normalizePathName(pathName) : 'HOME'}`;
  }, [pathname]);

  // Native overlay banners can cover navigation and are not part of the
  // measured viewport. Keep bounded app screens unobscured in all orientations.
  useEffect(() => {
    adMob.removeBanner();
    return () => { adMob.removeBanner(); };
  }, []);

  return (
    <PrimaryTopBar sendMessage={sendMessage || noop}>
      {() => (
        <Box
          component="main"
          id="main"
          className="bh-shell"
          display="grid"
          gridTemplateRows="auto"
          rowGap={1}
          overflow="hidden"
          width="100%"
          minWidth={0}
          maxWidth="100vw"
        >
          {children}
        </Box>
      )}
    </PrimaryTopBar>
  );
};

export const BhabiAppLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <SendWSMessageProvider>
      <BhabiAppLayoutWithoutCtx>{children}</BhabiAppLayoutWithoutCtx>
    </SendWSMessageProvider>
  );
};
